var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"builder-box"},[(!_vm.loading)?_c('div',{staticClass:"builder-box__body-wrapper"},[_c('v-tools-pages-preview',{attrs:{"to":{ name: 'tools.landings' },"request":_vm.request}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }